var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2439 0H3.70431C1.68161 0 0 1.91853 0 4.28571V25.7143C0 28.0815 1.68167 30 3.70378 30H26.2434C28.3183 30 30 28.0815 30 25.7143V4.28571C30.0005 1.91853 28.3688 0 26.2439 0ZM6.52176 4.28571C8.07782 4.28571 9.33922 5.72478 9.33922 7.5C9.33922 9.27522 8.13006 10.7143 6.52176 10.7143C4.91347 10.7143 3.70431 9.27522 3.70431 7.5C3.70431 5.72478 5.01795 4.28571 6.52176 4.28571ZM26.1852 25.1518C26.0209 25.5 25.7039 25.7143 25.3576 25.7143H4.81427C4.46086 25.7143 4.13749 25.488 3.97725 25.1283C3.81701 24.7689 3.84724 24.3375 4.05555 24.0114L8.16434 17.5828C8.34137 17.3036 8.62311 17.1429 8.92247 17.1429C9.22182 17.1429 9.50451 17.3063 9.68142 17.5831L11.5867 20.5637L17.0631 11.2489C17.2398 10.8951 17.5333 10.7143 17.8444 10.7143C18.1555 10.7143 18.4519 10.8932 18.6257 11.1914L26.1389 24.0485C26.332 24.375 26.3496 24.7969 26.1852 25.1518Z",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIco);
export default __webpack_public_path__ + "static/media/image_ico.de10c7b9a539d38fc4600575805a131a.svg";
export { ForwardRef as ReactComponent };